import dayjs from 'dayjs'

export function formatDateTime(dateTime) {
  if (!dateTime) return null
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}
